import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = { class: "kn-flex kn-relative" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 p-d-flex p-flex-column" }
const _hoisted_5 = { "data-test": "physical-model-name" }
const _hoisted_6 = {
  key: 0,
  class: "metaweb-tab-container p-d-flex p-flex-column kn-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_MetawebPhysicalModelList = _resolveComponent("MetawebPhysicalModelList")
  const _component_MetawebPropertyListTab = _resolveComponent("MetawebPropertyListTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MetawebForeignKeyTab = _resolveComponent("MetawebForeignKeyTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_MetawebPhysicalModelUpdateDialog = _resolveComponent("MetawebPhysicalModelUpdateDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.physicalModel.tables')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-rounded p-button-plain p-button-sm",
            onClick: _ctx.openUpdateDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('metaweb.physicalModel.updatePhysicalModel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "metaweb-right-border",
          style: _ctx.physDescriptor.style.mainListContainer
        }, [
          _createVNode(_component_MetawebPhysicalModelList, {
            style: _ctx.physDescriptor.style.mainList,
            propMeta: _ctx.meta,
            onSelected: _ctx.onSelectedItem
          }, null, 8, ["style", "propMeta", "onSelected"])
        ], 4)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedPhysicalModel?.name), 1)
        ]),
        _: 1
      }),
      (_ctx.selectedPhysicalModel)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_TabView, {
              class: "metaweb-tabview p-d-flex p-flex-column kn-flex",
              scrollable: "",
              "data-test": "tab-view"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, null, {
                  header: _withCtx(() => [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.physicalModel.propertyList')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_MetawebPropertyListTab, {
                      class: "p-m-2",
                      selectedPhysicalModel: _ctx.selectedPhysicalModel
                    }, null, 8, ["selectedPhysicalModel"])
                  ]),
                  _: 1
                }),
                (_ctx.selectedPhysicalModel?.type === 'TABLE')
                  ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                      header: _withCtx(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.physicalModel.foreignKey')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_MetawebForeignKeyTab, {
                          class: "p-m-2",
                          propForeignKeys: _ctx.selectedPhysicalModel.foreignKeys
                        }, null, 8, ["propForeignKeys"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MetawebPhysicalModelUpdateDialog, {
      visible: _ctx.updateDialogVisible,
      changedItem: _ctx.changedItem,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateDialogVisible = false)),
      onUpdated: _ctx.onPhysicalModelUpdate
    }, null, 8, ["visible", "changedItem", "onUpdated"])
  ]))
}